import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import FeaturedCourseCard, { FeaturedCourseSkeleton } from "./FeaturedCourseCard";
import { useTranslation } from "react-i18next";

export default function HomeCourse() {
  const { t } = useTranslation();
  const categories = useSelector((state) => state.categoryReducer);
  const select_home = useSelector((state) => state.homeReducer);
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith("/app");
  const prefix = isAppRoute ? "/app" : "";

  // the slice starts with id-only stubs, so treat slug-less items as still loading
  const courses = (select_home?.course || []).filter((c) => c?.slug);
  const loading = select_home?.loading || (courses.length === 0 && select_home?.course?.length > 0);

  return (
    <section className="featured-courses">
      <div className="container">
        <div className="fc-head">
          <div>
            <h2 className="fc-heading">{t("homeCourse.featured_courses")}</h2>
            <p className="fc-subtitle">{t("homeCourse.subtitle")}</p>
          </div>
          <Link to={`${prefix}/all-courses`} className="fc-view-all">
            {t("homeCourse.view_all")} <i className="fa-light fa-arrow-right" />
          </Link>
        </div>

        {categories?.data?.length > 0 && (
          <ul className="fc-categories">
            {categories.data.slice(0, 8).map((item) => (
              <li key={item.slug}>
                <Link to={`${prefix}/category/${item.slug}`} className="fc-category">{item.name}</Link>
              </li>
            ))}
          </ul>
        )}

        <div className="row g-4">
          {loading
            ? [0, 1, 2, 3].map((i) => (
                <div className="col-xl-3 col-lg-4 col-sm-6" key={i}>
                  <FeaturedCourseSkeleton />
                </div>
              ))
            : courses.slice(0, 8).map((course) => (
                <div className="col-xl-3 col-lg-4 col-sm-6" key={course.id}>
                  <FeaturedCourseCard course={course} />
                </div>
              ))}
        </div>
      </div>
    </section>
  );
}
